<script setup lang="ts">
import CardProgressContent from '@/components/ui/card/CardProgressContent.vue'
import type { KpiChiffreAffaireGlobalViewModel } from '@/lib/types'
import KpiChiffreDaffairesRepository from '@/repository/KpiChiffreDaffairesRepository'
import { onMounted, ref } from 'vue'
import Card from '@/components/ui/card/Card.vue'
import {formatCurrency, formatNumber} from "@/lib/format.ts";

const data = ref<KpiChiffreAffaireGlobalViewModel | null>(null)
const fields = ref<{ label: string; value: number }[]>([])
const apiData = ref<KpiChiffreAffaireGlobalViewModel | null>(null)

const updateFields = () => {
  if (!apiData.value) return

  data.value = apiData.value

  if (data.value) {
    const { chiffre_affaire_realise, chiffre_affaire_previsionnel } = data.value
    const percentage = chiffre_affaire_previsionnel > 0
      ? (chiffre_affaire_realise / chiffre_affaire_previsionnel) * 100
      : 0

    const formattedLabel =
        `Chiffre d'affaire prévisionnel réalisé (${formatCurrency(chiffre_affaire_realise)} / ${formatCurrency(chiffre_affaire_previsionnel)})`

    fields.value = [{
      label: formattedLabel,
      value: Number(percentage.toFixed(2))
    }]
  }
}

onMounted(async () => {
  apiData.value = await KpiChiffreDaffairesRepository.getInfoCardData()
  updateFields()
})
</script>

<template>
  <Card title="KPI chiffres d'affaires (mois)">
    <CardProgressContent :fields="fields" :skeletons="1" />
  </Card>
</template>
